// Models
import {Record as RecordModel} from "../../models"

type CommonParameters = NonNullable<RecordModel["commonParameters"]>

export type ParameterKey = keyof CommonParameters

export type ParameterLimit = {min: number, max: number}

export const PARAM_LIMITS: {[K in ParameterKey]: ParameterLimit} = {
    heartRate: {min: 20, max: 300},
    rrInterval: {min: 200, max: 3000},
    prInterval: {min: 40, max: 400},
    qrsDuration: {min: 40, max: 200},
    qtInterval: {min: 200, max: 800},
    qtcInterval: {min: 200, max: 800},
    qtcfInterval: {min: 200, max: 800},
    pDuration: {min: 20, max: 200},
    tDuration: {min: 40, max: 400},
    pAxis: {min: -180, max: 180},
    qrsAxis: {min: -180, max: 180},
    tAxis: {min: -180, max: 180},
};

/**
 * True when `value` is a number the server will accept for `key`.
 *
 * @param key
 * @param value
 */
export function acceptsParameter(key: ParameterKey, value: number): boolean {
    const limit = PARAM_LIMITS[key];

    return isFinite(value) && value >= limit.min && value <= limit.max
}
